"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UINavListItem = _interopRequireDefault(require("./UINavListItem"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var NavListItem = (0, _styledComponents.default)(_UINavListItem.default).withConfig({
  displayName: "UIFolderNavItem__NavListItem",
  componentId: "i8rfvu-0"
})(["left:0;padding:8px;padding-right:", ";width:100%;&.private-folder-nav-item.private-nav-item{font-size:14px;}.private-icon{max-width:15px;margin-right:0.5em;}"], _sizes.NAV_ITEM_PADDING_RIGHT);

var _default = (0, _createReactClass.default)({
  displayName: 'UIFolderNavItem',
  propTypes: Object.assign({}, _UINavListItem.default.propTypes),
  getDefaultProps: function getDefaultProps() {
    return Object.assign({}, _UINavListItem.default.defaultProps);
  },
  getIcon: function getIcon() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        children = _ref.children,
        className = _ref.className,
        open = _ref.open,
        size = _ref.size;

    var icon = 'file';

    if (children != null) {
      icon = open ? 'folderOpen' : 'folder';
    }

    return _react.default.createElement(_UIIcon.default, {
      className: (0, _classnames.default)('private-folder-nav-item__icon', className),
      name: icon,
      size: size,
      color: _colors.CALYPSO
    });
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className"]);
    return _react.default.createElement(NavListItem, Object.assign({
      className: (0, _classnames.default)('private-folder-nav-item', className),
      iconLeft: this.getIcon,
      hasChildren: children != null
    }, rest), children);
  }
});

exports.default = _default;
module.exports = exports.default;